const home = {
  heroAlt: "Специалисты изучают чертежи на ремонтном объекте",
  galleryAlt: "Строительство и ремонт",
  install: {
    iosSub: "Загрузите в",
    androidSub: "Доступно в",
    iosTitle: "Установка на iPhone/iPad",
    iosDesc: "Откройте эту страницу в Safari, нажмите «Поделиться», а затем «На экран „Домой“».",
    androidTitle: "Установка приложения",
    androidDesc: "Откройте меню браузера и выберите «Установить приложение» / «Добавить на главный экран».",
  },
  apps: {
    nuvliTitle: "Мобильное приложение NuvliPro",
    nuvliDesc: "Сметы, счета, объекты, расходы и учёт рабочего времени в вашем телефоне.",
    nuvliInstall: "Скачать NuvliPro",
    nuvliNote: "Прямая установка (PWA) · работает на Android и iPhone, не занимает место.",
    workerTitle: "Мобильное приложение «GPS-табель»",
    workerDesc: "Для сотрудников: отметка прихода/ухода с GPS и вход по коду доступа.",
    workerInstall: "Скачать «GPS-табель»",
    workerNote: "Для работников · после установки откройте приложение и войдите с кодом доступа.",
    workerCta: "Открыть приложение сотрудника",
    qrTitle: "Учёт рабочего времени с GPS",
    qrSubtitle: "Простая и надёжная отметка для вашей команды",
    qrText: "Скачайте бесплатно на нашем сайте",
    qrInstall: "Установить на телефон",
    qrAvailable: "Доступно для Android и iPhone",
  },
  login: {
    title: "Вход", email: "Эл. почта", password: "Пароль", emailPh: "vy@email.com", submit: "Войти",
    forgot: "Забыли пароль?", register: "Бесплатная регистрация", welcome: "Добро пожаловать", error: "Ошибка входа",
  },
  features: {
    badge: "Возможности",
    title: "Всё, что нужно для управления вашим бизнесом",
    items: [
      { t: "Счета", d: "Счета с автоматической нумерацией, НДС и удержаниями, статусами и загрузкой профессионального PDF." },
      { t: "Сметы", d: "Сметы по разделам и подробным позициям; превращайте их в счёт одним нажатием." },
      { t: "Контроль расходов", d: "Учитывайте материалы, работу и поставки; контролируйте расходы по объектам и категориям." },
      { t: "Частичные оплаты", d: "Фиксируйте авансы, следите за остатком задолженности и автоматически отправляйте квитанции." },
      { t: "Квартальные отчёты", d: "НДС и подоходный налог по кварталам — готово для бухгалтера и экспортируется в PDF и Excel." },
      { t: "Работа с клиентами", d: "Полная карточка каждого клиента, история документов и выявление просроченных платежей." },
    ],
  },
  pricing: {
    badge: "Тарифы и цены",
    title: "Выберите тариф, который лучше всего подходит вашему бизнесу",
    subtitle: "Начните бесплатно и без срока окончания. Переходите на платный тариф, когда понадобится: без обязательств, отмена в любой момент.",
    freeCta: "Создать бесплатный аккаунт",
    labels: { gratuito: "Бесплатный тариф", trimestral: "Квартальный тариф", anual: "Годовой тариф" },
    perMonth: "{{amount}}/мес.",
    approx: "≈ {{amount}}/мес.",
    periodo: { gratuito: "Без срока окончания", trimestral: "{{total}} каждые 3 месяца", anual: "{{total}} в год" },
    nota: { gratuito: "Чтобы начать без оплаты", trimestral: "Без ограничений, оплата раз в 3 месяца", anual: "Один платёж в год" },
    badges: { trimestral: "Самый популярный" },
    save: "Экономия {{amount}} в год",
    features: {
      gratuito: ["До 8 клиентов", "До 8 смет", "Счета и частичные оплаты для ваших 8 клиентов", "Расходы и квартальный учёт: последние 2 квартала", "2 строительных проекта", "Учёт рабочего времени без ограничения по работникам"],
      trimestral: ["Неограниченное число клиентов, смет и объектов", "Полная история расходов и кварталов", "ИИ, VeriFactu и сверка с банком", "Напоминания по эл. почте и WhatsApp", "Экспорт для бухгалтера"],
      anual: ["Всё из квартального тарифа", "Свои шаблоны документов и логотип", "Плановые автоматические уведомления", "Приоритетная поддержка"],
    },
    payCard: "Оплатить картой",
    payNote: "Карта: автопродление, отмена в любой момент",
    footnote: "Цены без НДС · Оплата картой · Безопасный платёж через Stripe",
    approxNote: "Приблизительная сумма в {{currency}} по сегодняшнему курсу. Точная сумма указана на странице оплаты.",
    payError: "Не удалось начать оплату",
  },
  trust: {
    title: "Профессионалы, которые уже доверяют NuvliPro",
    subtitle: "Реальные отзывы компаний из сферы строительства и ремонта.",
    testimonials: [
      { cargo: "Генеральный директор", empresa: "Constructora MendozaBuild S.A.", texto: "Больше десяти лет мы работали в Excel и системах, которые не были связаны между собой. С NuvliPro мы собрали всю информацию по нашим 8 проектам и сократили время на администрирование на 60%. Отчёты о рентабельности по каждому проекту теперь точные, и я принимаю решения на основе реальных данных, а не интуиции." },
      { cargo: "Директор по проектам", empresa: "Grupo Constructor Rojas & Asociados", texto: "Мы выросли с 3 до 12 активных проектов, и наша ручная система рухнула. С NuvliPro мы росли, не удваивая административный персонал: полная прослеживаемость каждого материала, контроль субподрядчиков в реальном времени и на 75% меньше итоговой документации. Наши клиенты получают отчёты, которые вызывают доверие." },
      { cargo: "Индивидуальный предприниматель", empresa: "18 лет в отрасли", texto: "Мои объекты становились всё сложнее и менее прибыльными, а расходы утекали неизвестно куда. С NuvliPro я нашёл финансовые утечки, сократил число поставщиков и снизил накладные расходы на 22% без потери качества. Теперь я готовлю более подробные сметы быстрее и заключаю больше договоров." },
    ],
    seals: [
      { t: "Соответствие GDPR", d: "Защищённые данные" },
      { t: "Шифрование SSL", d: "Безопасное соединение" },
      { t: "Платежи через Stripe", d: "Защищённые платежи" },
      { t: "Поддержка на испанском", d: "Когда она нужна" },
    ],
  },
  demo: {
    badge: "Демо-видео",
    title: "Знакомство с NuvliPro за 2 минуты",
    subtitle: "Посмотрите, как создать смету, превратить её в счёт и контролировать оплаты и расходы.",
    unsupported: "Ваш браузер не поддерживает воспроизведение видео.",
    soon: "Демо-видео скоро появится",
  },
  faq: {
    badge: "Частые вопросы",
    title: "Отвечаем на ваши вопросы",
    items: [
      { q: "Нужны ли знания бухгалтерии, чтобы пользоваться NuvliPro?", a: "Нет. NuvliPro создан для самозанятых и небольших компаний: вы создаёте сметы и счета, заполняя понятные поля, а приложение автоматически рассчитывает НДС, удержания и итоги." },
      { q: "Можно попробовать бесплатно?", a: "Да. Бесплатный тариф не имеет срока окончания и не требует карты: до 8 клиентов, 8 смет, 8 счетов и 1 активный строительный проект. Когда понадобится больше, перейдите на платный тариф." },
      { q: "Данные моих клиентов в безопасности?", a: "Да. Мы шифруем соединение (SSL), соблюдаем GDPR, а платежи безопасно обрабатываются через Stripe. Мы никогда не передаём ваши данные третьим лицам." },
      { q: "Можно оформить счета и сметы со своим логотипом?", a: "Да. В личном кабинете можно загрузить логотип компании и выбрать дизайн документа в стиле вашего бренда." },
      { q: "Подходит ли NuvliPro для квартального налогового учёта?", a: "Да. Приложение автоматически формирует сводку по начисленному/входящему НДС и подоходному налогу за квартал с экспортом в PDF и Excel для бухгалтера." },
      { q: "Можно отменить подписку в любой момент?", a: "Конечно. Обязательств нет: вы можете сменить или отменить тариф в любое время в своём аккаунте." },
    ],
  },
  contact: {
    badge: "Контакты",
    title: "Поговорим?",
    subtitle: "Расскажите, что вам нужно, и мы ответим как можно скорее. Мы поможем вам получить максимум от NuvliPro.",
    support: "Служба поддержки",
    supportNote: "Поддержка на испанском · ответ в течение 24-48 ч",
    name: "Имя", namePh: "Ваше имя", email: "Эл. почта", emailPh: "vy@email.com",
    message: "Сообщение", messagePh: "Чем мы можем помочь?", send: "Отправить сообщение",
    sent: "Сообщение отправлено! Скоро ответим.", error: "Не удалось отправить сообщение",
  },
  cta: {
    title: "Весь ваш бизнес в одном месте",
    items: ["Клиенты", "Сметы", "Счета", "Частичные оплаты", "Расходы", "Квартал", "Просрочки", "WhatsApp"],
    button: "Создать бесплатный аккаунт",
  },
  footer: "Комплексное управление для специалистов в строительстве и ремонте",
};
export default home;
